// Generated by GitHub Copilot
import { ApiError, apiErrorKey } from '#core/api/Api.ts'
import { State } from '#core/state/State.ts'

/** Why the browser could not be sent to the SSO provider. */
export type SsoRedirectNotice = 'notAvailable' | 'failed'

/** Drives a button that sends the browser to an SSO provider: busy until the page leaves, or the reason it could not. */
export class SsoRedirectState extends State<SsoRedirectState> {
  busy = false
  notice: SsoRedirectNotice | null = null

  constructor() {
    super(undefined, null)
  }

  /** Runs `start`, which leaves the page on success, so `busy` only clears on a failure. */
  async go(start: () => Promise<void>): Promise<void> {
    this.reactTo.busy = true
    this.reactTo.notice = null
    try {
      await start()
    } catch (e) {
      const status = e instanceof ApiError ? e.response?.status : undefined
      this.reactTo.notice = apiErrorKey(e) === 'not_configured' || status === 502 || status === 503 ? 'notAvailable' : 'failed'
      this.reactTo.busy = false
    }
  }
}
